export const projects = [
  {
    id: 1,
    title: "Asuraa - AI Career Platform",
    role: "Lead Developer",
    description: "An AI-powered data science career platform featuring intelligent resume parsing, personalized job matching, and real-time interview prep.",
    techStack: ["React", "Next.js", "Node.js", "AI Integration", "Tailwind CSS"],
    liveLink: "https://asuraa.in",
    githubLink: "",
    image: "/screenshots/asuraa.png", 
    featured: true
  },
  {
    id: 2,
    title: "RadiGo - Salon Booking System",
    role: "Creator & Developer",
    description: "A comprehensive smart salon booking system enabling real-time multi-chair scheduling, QR-based walk-in queues, and an admin live dashboard.",
    techStack: ["React", "Express", "MongoDB", "Framer Motion"],
    liveLink: "https://radigo.vercel.app",
    githubLink: "",
    image: "/screenshots/radigo.png", 
    featured: true
  },
  {
    id: 3,
    title: "StaySpot - Room Booking",
    role: "Full Stack Developer",
    description: "A seamless room booking platform allowing users to search, filter, and book accommodations with a rich, interactive UI.",
    techStack: ["React", "Node.js", "Express", "Material UI"],
    liveLink: "",
    githubLink: "https://github.com/PrasadNalajala/StaySpot",
    image: "/screenshots/stayspot.png", 
    featured: false
  },
  {
    id: 4,
    title: "Jobby - Job Search Portal",
    role: "Frontend Developer",
    description: "A responsive job portal connecting recruiters with candidates, featuring advanced search filters and profile management.",
    techStack: ["React", "Redux", "CSS3"],
    liveLink: "",
    githubLink: "https://github.com/PrasadNalajala/JobbyApp",
    image: "/screenshots/jobby.png", 
    featured: false
  },
  // {
  //   id: 5,
  //   title: "Live Weather App",
  //   role: "Developer",
  //   description: "A fast, beautiful weather application fetching real-time data using the OpenWeather API with dynamic background changes.",
  //   techStack: ["React", "OpenWeather API", "CSS Grid"],
  //   liveLink: "",
  //   githubLink: "https://github.com/PrasadNalajala/weather-app",
  //   image: "/screenshots/weatherapp.png", 
  //   featured: false
  // }
];
